import React from "react";

import { type FileItem } from "../../map-panel-context";

import { FileCard } from "./file-card";

interface SectionDocumentsProps {
  files: FileItem[];
}

export const SectionDocuments: React.FC<SectionDocumentsProps> = ({
  files,
}) => {
  return (
    <div className="flex w-full flex-col gap-2">
      {files.map((file, index) => (
        <FileCard
          key={index}
          fileName={file.fileName}
          fileSizeBytes={file.fileSizeBytes}
          onDownload={file.onDownload}
          onView={file.onView}
        />
      ))}
    </div>
  );
};